import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";

import ProcessLimit from "components/Costs/ProcessLimit";

class ProcessLimitContainer extends React.PureComponent {
  render() {
    return <ProcessLimit {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateProcessLimit: (processLimit) => dispatch(setupReducer.updateProcessLimit(ownProps.id, processLimit))
});

const mapStateToProps = (state, ownProps) => ({
  total: setupReducer.getTotal(state, ownProps.id),
  processLimit: setupReducer.getProcessLimit(state, ownProps.id),
  targeted: setupReducer.getTargeted(state, ownProps.id),
  timePeriod: setupReducer.getTimePeriod(state, ownProps.id)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ProcessLimitContainer);
